import QrService from "../services/qr.service"
import { getSession } from "@hooks/useSession"

/**
 * Récupère les détails du patient via lien chiffré.
 * @param {string} encryptedContent - Le segment chiffré dans l’URL
 * @returns {Promise<object>} Données patient ou erreur formatée
 */
const getQrScanDetails = async (encryptedContent) => {
  console.log("→ [QRController] Fetching scan details via encrypted URL:", { encryptedContent })

  const session = getSession()
  const token = session?.token

  const response = await QrService.fetchQrScanDetailsViaUrl(encryptedContent, token)

  console.log("→ [QRController] Response:", response)
  return response
}

/**
 * Génère une URL sécurisée pour le participant
 * @param {string} participantId - UUID du participant
 * @returns {Promise<object>} Objet contenant accessUrl ou erreur
 */
const generateQrCode = async (participantId) => {
  console.log("→ [QRController] Generating access URL with:", { participantId })

  const session = getSession()
  const token = session?.token

  const response = await QrService.generateQrCode({ id: participantId }, token)

  console.log("→ [QRController] Access URL Response:", response)
  return response
}

const QrController = {
  getQrScanDetails,
  generateQrCode,
}

export default QrController